import React from 'react'
import PropTypes from 'prop-types'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

import arrowRightIcon from '../../../shared/assets/icon-arrow-right.svg'

const NextSlide = ({ onClick, visible }) => {
  return (
    <CSSTransitionGroup
      transitionName='co_next-slide'
      transitionEnterTimeout={500}
      transitionLeaveTimeout={300}
    >
      {visible &&
        <div className='co_next-slide' style={{ backgroundImage: `url(${arrowRightIcon})` }} onClick={onClick} />
      }
    </CSSTransitionGroup>
  )
}

NextSlide.propTypes = {
  onClick: PropTypes.func,
  visible: PropTypes.bool
}

export default NextSlide



// WEBPACK FOOTER //
// ./src/templates/coffee/components/fixed/NextSlide.js